import {createApi} from "@reduxjs/toolkit/dist/query/react"
import {apiQuery, getUrl} from "../../utils/api-config";
import {Response} from "../../types/response/Response";
import {ExtendedInfoDTO} from "../../types/utils/InfoDTO";
import {CategoryCreateDTO, CategoryEditDTO} from "../../types/category/CategoryCreateDTO";
import {DeleteParams} from "../../types/utils/Constants";

export const categoryApi = createApi({
    reducerPath: "category",
    baseQuery: apiQuery,
    tagTypes: ["categories"],
    endpoints: builder => ({
        getCategories: builder.query<Response<ExtendedInfoDTO[]>, Partial<number | undefined>>({
            query: (accountId) => getUrl('/categories', [{name: "account_id", value: accountId}]),
            providesTags: ['categories']
        }),
        createCategory: builder.mutation <Response<void>, Partial<CategoryCreateDTO>>({
            query: (body) => ({
                url: "/categories",
                method: "POST",
                body
            }),
            invalidatesTags: ['categories']
        }),
        editCategory: builder.mutation <void, Partial<CategoryEditDTO>>({
            query: (dto) => ({
                url: `/categories/${dto.id}`,
                method: "PATCH",
                body: dto
            }),
            invalidatesTags: ['categories']
        }),
        deleteCategory: builder.mutation <void, Partial<DeleteParams>>({
            query: (params) => ({
                url: getUrl(`/categories/${params.id}`, [{name: "account_id", value: params.accountId}]),
                method: "DELETE",
            }),
            invalidatesTags: ['categories']
        })
    })
})

export const {
    useGetCategoriesQuery,
    useCreateCategoryMutation,
    useDeleteCategoryMutation,
    useEditCategoryMutation
} = categoryApi
